import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import { withResponsiveFlags } from '~/hoc/withResponsiveProps';
import AppBar from '~/ui/AppBar/AppBar.js';
import { getCurrentModelId, getAuthResult, } from "~/stateGetter";
import PageContainer from "~/ui/PageContainer/PageContainer";
import NavigationConfirmDialog from "~/ui/NavigationConfirmDialog/NavigationConfirmDialog";
import ModelConfigCache from "~/ui/ModelDataManager/ModConfigCache";
import getConfig from "~/config"
import DialogContainer from '~/ui/DialogContainer/DialogContainer';
import { AppWrapper } from "./AppWrapper";
import { Drawer } from "../Drawer"

class MainAppView extends Component {
    static propTypes = {};

    componentDidMount = () => {

    };

    render() {
        return (
            <AppWrapper>
                <NavigationConfirmDialog />

                {getConfig().cacheModels ? <ModelConfigCache /> : null}

                <Drawer
                    showDrawer={ !this.props.isSmallScreen && this.props.auth }
                    isSmallScreen={this.props.isSmallScreen}
                    appBar={<AppBar />}
                    body={PageContainer}
                />

                <DialogContainer />
            </AppWrapper>
        );
    }
}

const MainApp = connect((state) => {
    return {
        modelId: getCurrentModelId(state),
        auth: !!getAuthResult(state).value,
    };
})(MainAppView);

export default withResponsiveFlags(MainApp, { includeKeys: ['isSmallScreen'] });